var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "grid-section",
    style: _vm.style
  }, [_c('ContainerVue', [_c('div', {
    staticClass: "h-full grid items-center pt-6 pb-8",
    class: `grid-cols-${_vm.desktop.size.cols} gap-${_vm.desktop.size.gap} ${_vm.mobile.isMobileGrid && _vm.mobile.columns.length > 0 && 'sm-md:hidden'} sm-md:grid-cols-1`
  }, _vm._l(_vm.desktop.columns, function (column) {
    return _c('div', {
      key: column._key,
      staticClass: "px-5 py-5",
      style: _vm.columnStyle(column.styles)
    }, [column.content._type === 'complexBlockObject' ? _c('SanityBlockContent', {
      attrs: {
        "blocks": column.content.blocks
      }
    }) : _vm._e(), _vm._v(" "), column.content._type === 'table' ? _c('sanity-table', _vm._b({}, 'sanity-table', column.content, false)) : _vm._e()], 1);
  }), 0), _vm._v(" "), _vm.mobile.isMobileGrid && _vm.mobile.columns.length > 0 ? _c('div', {
    staticClass: "h-full justify-items-center items-center pt-6 pb-8",
    class: `grid-cols-${_vm.mobile.size.cols} gap-${_vm.mobile.size.gap} hidden sm-md:grid`
  }, _vm._l(_vm.mobile.columns, function (column) {
    return _c('div', {
      key: column._key,
      style: _vm.columnStyle(column.styles)
    }, [column.content._type === 'complexBlockObject' ? _c('SanityBlockContent', {
      attrs: {
        "blocks": column.content.blocks
      }
    }) : _vm._e(), _vm._v(" "), column.content._type === 'table' ? _c('sanity-table', _vm._b({}, 'sanity-table', column.content, false)) : _vm._e()], 1);
  }), 0) : _vm._e()])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };